import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ContentItem, ContentSliceState } from './ContentType';
import { fetchMovies, fetchTrendMovies, fetchTrends, fetchUpdateMovies } from './asyncActions';

const initialState: ContentSliceState = {
    content: [],
    totalCount: 0,
    homePage: 1,
    trendPage: 1,
    status: 'loading',
    name: '',
    fetching: true,
}

export const ContentSlice = createSlice({
    name: 'content',
    initialState,
    reducers: {
        setContent: (state, action: PayloadAction<ContentItem[]>) => {
            state.content = action.payload
        },
        setPushContent: (state, action: PayloadAction<ContentItem[]>) => {
            let copyPost = { ...state };
            copyPost.content.push(...action.payload);
            state = copyPost;
        },
        setHomePage: (state, action: PayloadAction<number>) => {
            state.homePage = action.payload
        },
        setTrendPage: (state, action: PayloadAction<number>) => {
            state.trendPage = action.payload
        },
        setTotalCount: (state, action: PayloadAction<number>) => {
            state.totalCount = action.payload
        },
        setName: (state, action: PayloadAction<string>) => {
            state.name = action.payload
        },
        setFetching: (state, action: PayloadAction<boolean>) => {
            state.fetching = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchMovies.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(fetchTrendMovies.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(fetchUpdateMovies.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(fetchTrends.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(fetchMovies.fulfilled, (state, action) => {
            state.content = action.payload.movies;
            state.homePage += 1;
            state.totalCount = action.payload.movie_count;
            state.status = 'completed'
        });
        builder.addCase(fetchTrends.fulfilled, (state, action) => {
            state.content = action.payload.movies;
            state.trendPage += 1;
            state.totalCount = action.payload.movie_count;
            state.status = 'completed'
        });
        builder.addCase(fetchUpdateMovies.fulfilled, (state, action) => {
            if (action.payload.movies) {
                state.homePage = state.homePage + 1;
                state.totalCount = action.payload.movie_count;
                state.content.push(...action.payload.movies)
                state.fetching = false;
                state.status = 'completed'
            } else {
                alert('There are no more movies ')
                window.scrollTo(0, 0);
                state.status = 'completed'
                state.fetching = false;
            }
        });
        builder.addCase(fetchTrendMovies.fulfilled, (state, action) => {
            if (action.payload.movies) {
                state.trendPage = state.trendPage + 1;
                state.totalCount = action.payload.movie_count;
                state.content.push(...action.payload.movies)
                state.fetching = false;
                state.status = 'completed'
            } else {
                alert('There are no more movies ')
                window.scrollTo(0, 0);
                state.status = 'completed'
                state.fetching = false;

            }
        });
        builder.addCase(fetchMovies.rejected, () => {
            console.log('error')
        });
        builder.addCase(fetchTrends.rejected, () => {
            console.log('error')
        });
        builder.addCase(fetchUpdateMovies.rejected, () => {
            console.log('error')
        });
        builder.addCase(fetchTrendMovies.rejected, () => {
            console.log('error')
        });
    },
})

export const { setContent, setTotalCount, setName, setFetching, setHomePage, setTrendPage, setPushContent } = ContentSlice.actions;

export default ContentSlice.reducer;